// extracted by mini-css-extract-plugin
module.exports = {"Container":"Partnerships_Container__JvjWs","item":"Partnerships_item__PRelD"};